import { Link } from 'react-router-dom';
import { PageShell, PageHero } from '@/components/site/PageShell';
import { Seo } from '@/components/seo/Seo';
import { guides } from '@/content/guides';
import { ArrowRight } from '@phosphor-icons/react';

export const GuideCard = ({ g }) => (
  <Link to={`/guides/${g.slug}`} className="group block border border-[#E4E4E7] hover:border-[#0047FF] transition-colors" data-testid={`guide-card-${g.slug}`}>
    <div className="aspect-[16/9] overflow-hidden bg-[#F4F4F5]">
      <img src={g.image} alt={g.imageAlt} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
    </div>
    <div className="p-6">
      <p className="font-mono text-xs uppercase tracking-widest text-[#0047FF] mb-2">{g.category} · {g.readMinutes} min read</p>
      <h2 className="font-heading text-lg font-bold tracking-tight text-[#09090B] group-hover:text-[#0047FF] transition-colors">{g.title}</h2>
      <p className="mt-2 text-sm text-[#71717A] leading-relaxed">{g.description}</p>
      <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-[#09090B]">
        Read guide <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
      </span>
    </div>
  </Link>
);

export default function GuidesPage() {
  return (
    <PageShell testId="guides-page">
      <Seo title="Game Guides & Articles" description="Free game guides from DashLink Gaming: Tic-Tac-Toe strategy, Checkers rules and tactics, finding a gaming squad and hosting watch parties." />
      <PageHero eyebrow="Guides" title="Play smarter. Team up better.">
        <p>Strategy guides for the games you can play on DashLink, and practical advice for building a squad you actually enjoy playing with.</p>
      </PageHero>
      <div className="max-w-6xl mx-auto px-6 py-16 grid gap-8 md:grid-cols-2" data-testid="guides-list">
        {guides.map((g) => <GuideCard key={g.slug} g={g} />)}
      </div>
    </PageShell>
  );
}
